var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{attrs:{"fixed-top":""}}),_vm._v(" "),_c('section',{staticClass:"main-content columns"},[_c('div',{staticClass:"container column is-10"},[_c('nuxt'),_vm._v("\n      .\n    ")],1)]),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }